// extracted by mini-css-extract-plugin
export default {"navTitle":"_MOh5AbN"};